import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'swodoc-node-contact',
  templateUrl: 'swodoc-node-contact.html',
  styleUrls: ['swodoc-node-contact.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeContact implements OnInit {
  @Input()
  node: any;
  @Output()
  changed: EventEmitter<any> = new EventEmitter<any>();
  contact = {
    name: true,
    organization: true,
    function: true,
    street: true,
    zip: true,
    city: true,
    phone: true,
    fax: true,
    mobile: true,
    email: true,
    website: true,
  };
  ngOnInit(): void {
    if (!this.node) {
      return;
    }
    if (!this.node.responses || this.node.responses === undefined || this.node.responses.length === 0) {
      this.initNodeResponses();
    }
    if (this.node.options && this.node.options.contact) {
      this.contact = this.node.options.contact;
    }
  }

  private initNodeResponses() {
    this.node.responses = [];
    for (const e in this.contact) {
      if (this.contact.hasOwnProperty(e)) {
        this.node.responses.push({ value: '' });
      }
    }
  }

  private getter(index) {
    if (this.node.responses[index].value) {
      return this.node.responses[index].value;
    }
  }
  private setter(index, value) {
    this.node.responses[index] = { value };
    this.emit();
  }
  get name(): string {
    return this.getter(0);
  }
  set name(value: string) {
    this.setter(0, value);
  }
  get organization(): string {
    return this.getter(1);
  }
  set organization(value: string) {
    this.setter(1, value);
  }
  get function(): string {
    return this.getter(2);
  }
  set function(value: string) {
    this.setter(2, value);
  }
  get street(): string {
    return this.getter(3);
  }
  set street(value: string) {
    this.setter(3, value);
  }
  get zip(): string {
    return this.getter(4);
  }
  set zip(value: string) {
    this.setter(4, value);
  }
  get city(): string {
    return this.getter(5);
  }
  set city(value: string) {
    this.setter(5, value);
  }
  get phone(): string {
    return this.getter(6);
  }
  set phone(value: string) {
    this.setter(6, value);
  }
  get fax(): string {
    return this.getter(7);
  }
  set fax(value: string) {
    this.setter(7, value);
  }
  get mobile(): string {
    return this.getter(8);
  }
  set mobile(value: string) {
    this.setter(8, value);
  }
  get email(): string {
    return this.getter(9);
  }
  set email(value: string) {
    this.setter(9, value);
  }
  get website(): string {
    return this.getter(10);
  }
  set website(value: string) {
    this.setter(10, value);
  }

  openContactPicker() {
    // this.contacts.pickContact().then(contact => {
    //   this.initNodeResponses();
    //   if (this.contact.name && contact.name && contact.name.formatted) {
    //     this.node.responses[0].value = contact.name.formatted;
    //   }
    //   if (this.contact.organization && contact.organizations.length > 0) {
    //     this.node.responses[1].value = contact.organizations[0].name;
    //   }
    //   if (this.contact.function && contact.organizations.length > 0) {
    //     this.node.responses[2].value = contact.organizations[0].title;
    //   }
    //   if (this.contact.street && contact.addresses.length > 0) {
    //     this.node.responses[3].value = contact.addresses[0].streetAddress;
    //   }
    //   if (this.contact.zip && contact.addresses.length > 0) {
    //     this.node.responses[4].value = contact.addresses[0].postalCode;
    //   }
    //   if (this.contact.city && contact.addresses.length > 0) {
    //     this.node.responses[5].value = contact.addresses[0].locality;
    //   }
    //   if (contact.phoneNumbers.length > 0) {
    //     const phone = contact.phoneNumbers.find(f => f.type === 'work' || f.type === 'home');
    //     const fax = contact.phoneNumbers.find(f => f.type === 'fax');
    //     const mobile = contact.phoneNumbers.find(f => f.type === 'mobile');
    //     if (this.contact.phone && phone) {
    //       this.node.responses[6].value = phone.value;
    //     }
    //     if (this.contact.fax && fax) {
    //       this.node.responses[7].value = fax.value;
    //     }
    //     if (this.contact.mobile && mobile) {
    //       this.node.responses[8].value = mobile.value;
    //     }
    //   }
    //   if (this.contact.email && contact.emails.length > 0) {
    //     this.node.responses[9].value = contact.emails[0].value;
    //   }
    //   if (this.contact.website && contact.urls.length > 0) {
    //     this.node.responses[10].value = contact.urls[0].value;
    //   }
    //   this.emit();
    // });
  }
  private emit() {
    this.changed.emit(this.node);
  }
}
